import { createContext } from "react";

const ChatBotContext = createContext({});

const ChatBotContextProvider = ({ children }) => {
  return (
    <ChatBotContext.Provider value={{}}>{children}</ChatBotContext.Provider>
  );
};
export {ChatBotContext, ChatBotContextProvider}